<style>

.spin{
  animation: spin 2s linear infinite;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.spinner{
  width: 33px;
  height: 33px;
}

</style>

<div>
  <img src="/i/spinner.svg" alt="" class="spinner" class:spin>
  <!-- <i class="icon-spinner2 spinner" ></i> -->
</div>

<script>

export let spin = true;

</script>